import React from "react";
import styles from "./TreeNode.module.css";
import PureJSComponentFactory from "../Pages/Factory/pureJSComponentFactory";

const TreeNode = ({
  node,
  expanded,
  toggle,
  onDrop,
  onReorder,
  selectedId,
  setSelected,
  handleSelectItem,
  onDoubleClick,
  template,
}) => {
  const dragStart = (e) => {
    e.dataTransfer.setData("dragId", node.id);
    e.dataTransfer.setData("parentId", node.parentId);
  };

  const dragOver = (e) => e.preventDefault();

  const drop = (e) => {
    e.preventDefault();
    const dragId = parseInt(e.dataTransfer.getData("dragId"), 10);
    const sourceParentId = parseInt(e.dataTransfer.getData("parentId"), 10);

    if (dragId === node.id) return;

    // Move to directory
    if (node.isDirectory) {
      onDrop(dragId, node.id);
    }
    // Reorder among siblings
    else if (sourceParentId === node.parentId) {
      onReorder(dragId, node.id, node.parentId);
    }
  };

  return (
    <div style={{ marginLeft: 20 }}>
      <div
        className={`${styles.treeNode} ${
          selectedId === node.id ? styles.selected : ""
        }`}
        draggable
        onDragStart={dragStart}
        onDragOver={dragOver}
        onDrop={drop}
        onDoubleClick={() => {
          onDoubleClick(node);
        }}
        onClick={() => {
          handleSelectItem(node);
          setSelected(node.id);
        }}
      >
        {node.children.length > 0 ? (
          <span onClick={() => toggle(node.id)} className={styles.expandIcon}>
            {expanded[node.id] ? "▼" : "▶"}
          </span>
        ) : (
          <span style={{ width: 14, display: "inline-block" }} />
        )}

        <span
          className={`${styles.icon} ${
            node.isDirectory
              ? expanded[node.id]
                ? styles.folderOpenIcon
                : styles.folderIcon
              : styles.fileIcon
          }`}
        />

        <span>{node.name}</span>
      </div>

      {expanded[node.id] &&
        node.children.map((child) => (
          <TreeNode
            key={child.id}
            node={child}
            expanded={expanded}
            toggle={toggle}
            onDrop={onDrop}
            onReorder={onReorder}
            selectedId={selectedId}
            setSelected={setSelected}
            handleSelectItem={handleSelectItem}
            onDoubleClick={onDoubleClick}
          />
        ))}
    </div>
  );
};

export default TreeNode;
